<template lang="pug">
.LndCases
  h2.d-flex
    span(v-html="L.header")

  ul.__slider.u-span-x.t-miniscroll.d-flex.--col(ref="slider",
      :class="mq.sm && '--col'")
    li.__case(v-for="(case$, i) of L.list", :class="`--${ case$.$company }`")
      header.d-flex.--middle(:class="mq.sm && '--wrap'")
        //- span.__ind {{ i + 1 }}
        span.__logo: img(:src="logos[case$.$company]")
        h3(v-html="case$.name")
        template(v-if="case$.desc")
          hr.d-not-sm
          span.__desc(v-html="case$.desc")

      ul.__list.d-flex(:class="mq.sm && '--col'",
          :style="`--len: ${ case$.list.length }`")
        li(v-for="item of case$.list")
          h4(v-if="!(!item.header && mq.sm)", v-html="item.header || '&nbsp;'")
          ul.__content.ul-disk(v-if="Array.isArray(item.content)")
            li(v-for="li of item.content", v-html="li")
          p(v-else, v-html="item.content")

</template>
<script>
import content, { logos } from 'content';
import { bindScrollSlide } from 'utils';

export default {
  name: 'LndCases',

  inject: ['mq'],

  static: () => ({
    L: content.cases,
    logos,
  }),

  mounted () {
    this.slide = bindScrollSlide(this.$refs.slider);
  },
};

</script>
<style>
.LndCases {
  .__case {
    --header-h: 40px;
    font-size: 14px;
    line-height: 30px;

    > header {

      h3 {
        color: var(--text-c);
        font-size: 14px;
      }
      hr {
        height: var(--header-h);

        border-left: 1px solid var(--border-c);
      }
    }
  }

  .__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--header-h);
    height: var(--header-h);
    padding: 3px;

    border: 1px solid var(--border-c);

    img {
      width: 100%;
      height: 100%;
    }
  }

  .--eve .__logo img { object-fit: contain }
  .--raif .__logo img {
    object-fit: cover;
    object-position: -2px;

    filter: grayscale(1);
  }

  .__list {
    b { color: var(--text-c) }
    h4 { margin-bottom: 24px; }
  }
}

@media (min-width: 740px) {
  .LndCases {
    h2 { margin-bottom: 52px }
    .__case {
      > header {
        --gap-h: 30px;
        height: var(--header-h);
        margin-bottom: 40px;
      }
    }

    .__list {
      --len: 1;
      padding: 30px 60px;
      background: var(--bg-c);

      /*> * { flex: 2 2 calc(100% / var(--len)) }*/
      > * { flex: 2 2 100% }
    }

    .__slider {
      --gap-v: var(--page-pad);

      width: calc(100% + var(--page-pad) * 2);
      margin: 0 calc(-1 * var(--page-pad));
      padding-bottom: 16px;

      > li {
        padding: 0 var(--page-pad);
      }

      &.u-span-x {
        overflow-x: auto;
        overflow-x: overlay;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;

        > * {
          scroll-snap-align: start;
        }
      }

      > * {
        display: inline-block;
        min-width: 100%;
        /*margin-left: 32px;*/
        vertical-align: top;
      }
    }

    .__ctrs {
      button {
        position: relative;
        --c: var(--text-c);
        --s: 35px;
        width: var(--s);
        height: var(--s);

        background: transparent;
        box-shadow: 0 0 0 1px var(--c) inset;
        border-radius: 50%;

        transition: all .2s;

        &:hover, &:focus {
          filter: invert(.1) blur(.5px) contrast(2);
          background: var(--white);
        }

        &::after {
          --s: 7px;
          position: absolute;
          top: calc(50% - var(--s) / 2);
          left: calc(50% - var(--s) / 2);

          display: block;
          width: var(--s);
          height: var(--s);

          border: 1px solid var(--c);
          border-width: 0 0 1px 1px;
          /*box-shadow: 1px 1px 0 1px var(--c);*/

          transform: rotate(45deg);
          transform-origin: center;

          content: '';

        }
        &:last-child::after {
          top: calc(50% - var(--s) / 2);
          left: initial;
          right: calc(50% - var(--s) / 2);
          transform: rotate(-135deg);
          /*border-width: 1px 1px 0 0;*/
        }

        &:disabled {
          --c: var(--border-c);
        }
      }
    }
  }
}

/*SM*/
@media (max-width: 739px) {
  .LndCases {
    h2 { margin-bottom: 60px }
    .__slider {
      --gap-v: 100px;
    }
    .__case {
      > header {
        --gap-h: 24px;
        margin-bottom: 80px;
      }
    }
    .__desc {
      font-weight: bold;
      width: 100%;
    }

    .__list {
      --gap-v: 40px;

      h4 {
        margin-bottom: 2em;
      }
    }

    .__content {

    }
  }
}
</style>
